import React from 'react';
import { Modal, Stack, Text, Group, Button, ThemeIcon, Title } from '@mantine/core';
import { IconCheck, IconAlertCircle } from '@tabler/icons-react';
import { primaryColor } from '../../constants/theme';

interface ChangePasswordModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  message: string;
  isSuccess: boolean;
}

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  opened,
  onClose,
  title,
  message,
  isSuccess,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      data-testid="change-password-modal"
    >
      <Stack gap="lg" align="center">
        <Title order={4} fw="normal" ta="center">
          {title}
        </Title>

        <ThemeIcon
          size={80}
          radius="50%"
          color={isSuccess ? primaryColor : 'red'}
          variant="light"
        >
          {isSuccess ? (
            <IconCheck size={48} stroke={2} />
          ) : (
            <IconAlertCircle size={48} stroke={2} />
          )}
        </ThemeIcon>

        <Text ta="center" size="md">
          {message}
        </Text>

        <Group justify="center" w="100%">
          <Button
            onClick={onClose}
            color={primaryColor}
            data-testid="modal-close-button"
            fullWidth
          >
            OK
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ChangePasswordModal;
